<div class="flex-column" style="height: 100%;">
  <div class="menu-group-box" data-type="view">

    <div class="gather-box">

      <div class="img-box"><img src="{{ makeImageUrl(videoStory?.image ?? null) }}"></div>

      <div class="info-box">
        <div class="main-box">{{ videoStory?.title ?? '모든 지역' }}</div>
        <div class="sub-box"
             *ngIf="videoStory?.regions">{{ videoStory?.regions }}개의 지역</div>

      </div>
    </div>


  </div>


  <app-movie-list></app-movie-list>
</div>
